import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { error } from 'protractor';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleCloudService {
  preAuthenticatedRequestString: string;

  constructor(private http: HttpClient, private env: EnvironmentService, private route: ActivatedRoute) {
  }

  arrangeDirPath(path: string): string {
    path = path.replace("./", "").replace(this.env.envVariables.syncStoreRoute, "").replace(this.env.envVariables.workStoreRoute, "");
    if (path.substring(0, 1) == "/") path = path.substring(1);
    return path;
  }

  getStorageData(depName: string, bucketName: string, path: string) {
    path = this.arrangeDirPath(path);
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/bucket/${bucketName}/listobjects`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache').set('Path', path == "" ? path : path + "/")
    return this.http.get(url, { headers: headers });
  }

  deleteObject(depName: string, bucketName: string, dirPath: string) {
    let objectName = dirPath.split("/")[dirPath.split("/").length - 1];
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/bucket/${bucketName}/deleteobject`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/octet-stream')
      .set('Cache-Control', 'no-cache')
      .set('ObjectName', objectName)
      .set('folderPath', this.arrangeDirPath(dirPath))
    return this.http.delete(url, { headers: headers });
  }

  createFolder(depName: string, dirPath: string, bucketName: string) {
    let folderName = dirPath.split("/")[dirPath.split("/").length - 1];
    let headers = new HttpHeaders();
    headers = headers.set('Cache-Control', 'no-cache')
      .set('folderPath', this.arrangeDirPath(dirPath));
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/bucket/${bucketName}/createfolder/${folderName}`;
    return this.http.put(url, null, { headers: headers });
  }

  downloadFile(depName: string, bucketName: string, dirPath: string) {
    let objectName = dirPath.split("/")[dirPath.split("/").length - 1];
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('folderPath', this.arrangeDirPath(dirPath));
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/bucket/${bucketName}/object/${objectName}/getDownloadLink`;
    return this.http.get(url, { headers, responseType: 'text' });
  }

  uploadFilePresignedUrl(depName: string, bucketName: string, dirPath: string) {
    let objectName = dirPath.split("/")[dirPath.split("/").length - 1];
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('folderPath', this.arrangeDirPath(dirPath));
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/bucket/${bucketName}/object/${objectName}/getUploadLink`;
    return this.http.get(url, { headers, responseType: 'text' });
  }

  viewFileData(depName: string, bucketName: string, dirPath: string) {
    let objectName = dirPath.split("/")[dirPath.split("/").length - 1];
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/bucket/${bucketName}/object/${objectName}/getFileData`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('folderPath', this.arrangeDirPath(dirPath));
    return this.http.get(url, { headers, responseType: 'text' });
  }

  uploadObject(url: string, file: File) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/octet-stream')
      .set('Cache-Control', 'no-cache').set('Access-Control-Allow-Origin', '*')
    return this.http.put(url, file, {
      headers,
      reportProgress: true,
      observe: 'events'
    });
  }

  async verifyDirectoryPath(deploymentName: string, storageName: string, paths: string[]): Promise<boolean> {
    for (const path of paths) {
      try {
        await this.createFolder(deploymentName, path, storageName).toPromise();
      } catch (error) {
        console.error(`Directory might already exist: ${path}`);
      }
    }
    return true;
  }
}
